// import React, { useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
// import { useNavigate, useParams } from "react-router-dom";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import WSBackButton from "../../../Components/BackButton/BackButton";
// import { Box, Divider, Grid, Paper, Typography } from "@mui/material";
// import WSHorizontalTimeline from "../../../Components/Timeline/WSHorizontalTimeLine";
// import WSSelectField from "../../../Components/Select/WSSelect";
// import config from "../../../Config/clientConfig.json";
// import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
// import WSTextField from "../../../Components/TextBox/WSTextBox";
// import WSImageUpload from "../../../Components/FileUpload/WSImageUpload";
// import PrescriptionDrawer from "./PrescriptionDrawer";
// import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";

// export const PrescriptionOrderDetails: React.FC<any> = React.memo((props) => {
//   const { control, register, setValue, reset, handleSubmit } = useForm();
//   const [open, setOpen] = React.useState(false);
//   const [formComponent, setFormComponent] = useState<any>();

//   const params = useParams();
//   const id = params?.id;
//   const handleOrderData = () => {};

//   useEffect(() => {
//     breadCrumbsStore.updateBreadCrumbs([
//       { Orders: "pharmacy-orders/list" },
//       {
//         [!id ? "Prescription Order Details" : ""]: "/",
//       },
//     ]);
//   }, [id]);

//   const steps = [
//     { label: "Order Placed", completed: true, icon: <WSIcons.FiPackage /> },
//     {
//       label: "Delivery Assigned",
//       completed: true,
//       icon: <WSIcons.TbUserSquareRounded />,
//     },
//     {
//       label: "Sample Collected",
//       completed: true,
//       icon: <WSIcons.RiRidingLine />,
//     },
//     {
//       label: "Report Uploaded",
//       completed: true,
//       icon: <WSIcons.BsArrowUpSquare />,
//     },
//   ];

//   const handleOrderInfo = () => {
//     const form: any = (
//       <PrescriptionDrawer
//         id="emailAdd"
//         control={control}
//         register={register}
//         reset={reset}
//         setValue={setValue}
//         onCancel={() => {
//           reset();
//           setOpen(false);
//           setFormComponent(null);
//         }}
//       />
//     );
//     setFormComponent(form);
//     setTimeout(() => {
//       setOpen(true);
//     }, 10);
//   };

//   return (
//     <>
//       <WSBackButton id="btnScheduleBack" url={"/labtestpackage/list"} />
//       <Paper
//         elevation={0}
//         style={{
//           paddingLeft: 20,
//           paddingRight: 20,
//           marginTop: 20,
//           paddingBottom: 25,
//           borderRadius: "8px",
//         }}
//       >
//         <Grid container spacing={2}>
//           <Grid item sm={12} xs={12}>
//             <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//               Order Timeline
//             </Typography>
//           </Grid>
//           <Grid item sm={12} xs={12}>
//             <WSHorizontalTimeline steps={steps} />
//           </Grid>
//         </Grid>
//       </Paper>
//       <Paper
//         elevation={0}
//         style={{
//           paddingLeft: 20,
//           paddingRight: 20,
//           marginTop: 20,
//           paddingBottom: 25,
//           borderRadius: "8px",
//         }}
//       >
//         <Grid container spacing={2} mt={2}>
//           <Grid item sm={4} xs={12}>
//             <Typography>Order ID</Typography>
//           </Grid>
//           <Grid item sm={4} xs={12}>
//             <Typography>Status</Typography>
//           </Grid>
//           <Grid item sm={4} xs={12}>
//             <Typography>Action</Typography>
//           </Grid>{" "}
//           <Grid item xs={12}>
//             <Divider style={{ marginTop: 10 }} />
//           </Grid>
//           <Grid item sm={4} xs={12}>
//             <Typography>#ygghj</Typography>
//           </Grid>
//           <Grid item sm={4} xs={12}>
//             <WSSelectField
//               rules={{ required: true }}
//               {...register("status")}
//               id="status"
//               control={control}
//               label=""
//               name="status"
//               options={config.statusConfig.staticOptionData}
//               sx={{ width: "131px" }}
//             />
//           </Grid>
//           <Grid item sm={2} xs={12}>
//             <WSSelectField
//               rules={{ required: true }}
//               {...register("action")}
//               id="action"
//               control={control}
//               label=""
//               name="action"
//               options={config.statusConfig.staticOptionData}
//               sx={{ width: "131px" }}
//             />
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <Grid
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1,
//                 px: 2,
//                 py: 1,
//                 bgcolor: "#DDF6EC",
//                 borderRadius: 2,
//                 minWidth: 160,
//                 justifyContent: "center",
//               }}
//             >
//               <Grid
//                 sx={{
//                   color: "#33B78E",
//                   fontSize: 20,
//                   display: "flex",
//                   alignItems: "center",
//                 }}
//               >
//                 <WSIcons.VisibilityIcon />
//               </Grid>

//               <Typography
//                 sx={{
//                   fontSize: 14,
//                   fontWeight: 600,
//                   color: "#1E8A67",
//                 }}
//               >
//                 Delivery Report
//               </Typography>
//             </Grid>
//           </Grid>
//         </Grid>
//       </Paper>
//       <Grid container spacing={2} mt={2}>
//         <Grid item xs={12} sm={6}>
//           <Paper
//             elevation={0}
//             style={{
//               paddingLeft: 20,
//               paddingRight: 20,
//               marginTop: 0,
//               paddingBottom: 25,
//               borderRadius: "8px",
//             }}
//           >
//             <Grid container spacing={2} mt={0}>
//               <Grid item sm={12} xs={12}>
//                 <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//                   Patient Information
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={3}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   Patient Name
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={7}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   : Kiran{" "}
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={3}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   Age
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={7}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   : 50{" "}
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={3}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   Contact Number
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={7}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   : 96946665{" "}
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={3}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   Address
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={7}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   : First line{" "}
//                 </Typography>
//                 <Typography variant="body2" color={"GrayText"}>
//                   second line{" "}
//                 </Typography>
//                 <Typography variant="body2" color={"GrayText"}>
//                   third line{" "}
//                 </Typography>
//                 <Typography variant="body2" color={"GrayText"}>
//                   fourth line{" "}
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={3}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   Patient ID
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={7}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   : PNT-545
//                 </Typography>
//               </Grid>
//             </Grid>
//           </Paper>
//         </Grid>
//         <Grid item xs={12} sm={6}>
//           <Paper
//             elevation={0}
//             style={{
//               paddingLeft: 20,
//               paddingRight: 20,
//               marginTop: 0,
//               paddingBottom: 25,
//               borderRadius: "8px",
//               height: "19rem",
//             }}
//           >
//             <Grid container spacing={2} mt={0}>
//               <Grid item sm={11} xs={12}>
//                 <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//                   Order Information
//                 </Typography>
//               </Grid>
//               <Grid item sm={1} xs={12}>
//                 <WSIcons.FaRegEdit onClick={handleOrderInfo} />
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   Total Items
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={7}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   : 3
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   Sub Total
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={7}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   : ₹480
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   Delivery Fee
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={7}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   : ₹25
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   Payment
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={7}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   : Paid
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   Medicine Name
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={7}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   : Dolo 650 Tablet (15 Tablets) - 6, Allopurinol - 2,
//                   Amoxicillin - 5
//                 </Typography>
//               </Grid>
//             </Grid>
//           </Paper>
//         </Grid>
//       </Grid>
//       <Paper
//         elevation={0}
//         style={{
//           paddingLeft: 20,
//           paddingRight: 20,
//           marginTop: 40,
//           paddingBottom: 25,
//           borderRadius: "8px",
//         }}
//       >
//         <Grid container spacing={2}>
//           <Grid item sm={12} xs={12}>
//             <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//               Prescription Image
//             </Typography>
//           </Grid>
//           <Grid item xs={12}>
//             <Divider />
//           </Grid>{" "}
//           <Grid item xs={12}>
//             <WSImageUpload
//               control={control}
//               id="image"
//               name="image"
//               label=""
//               rules={{ required: false }}
//             />
//           </Grid>
//         </Grid>
//       </Paper>
//       <Paper
//         elevation={0}
//         style={{
//           paddingLeft: 20,
//           paddingRight: 20,
//           marginTop: 40,
//           paddingBottom: 25,
//           borderRadius: "8px",
//         }}
//       >
//         <Grid container spacing={2}>
//           <Grid item sm={12} xs={12}>
//             <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//               Delivery Details
//             </Typography>
//           </Grid>
//           <Grid item xs={12}>
//             <Divider />
//           </Grid>{" "}
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color={"GrayText"} mt={2}>
//               Assigned Technician :
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={8}>
//             <WSTextField
//               control={control}
//               id="test"
//               name="test"
//               rules={{ required: true }}
//               label=""
//             />
//             <WSSelectField
//               rules={{ required: true }}
//               {...register("assigned")}
//               id="assigned"
//               control={control}
//               label=""
//               name="assigned"
//               options={config.statusConfig.staticOptionData}
//               sx={{ mt: 2, width: 150 }}
//             />
//           </Grid>
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color={"GrayText"} mt={2}>
//               Delivery Status :
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={8}>
//             <WSSelectField
//               rules={{ required: true }}
//               {...register("collected")}
//               id="collected"
//               control={control}
//               label=""
//               name="collected"
//               options={config.statusConfig.staticOptionData}
//               sx={{ mt: 2, width: 150 }}
//             />
//           </Grid>
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color={"GrayText"} mt={2}>
//               Order ID
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <Typography variant="body2" color={"GrayText"} mt={2}>
//               : HC115564
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color={"GrayText"} mt={2}>
//               Order Received Date & Time
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <Typography variant="body2" color={"GrayText"} mt={2}>
//               : 3/06/2025 09:30 - 10:00 PM
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color={"GrayText"} mt={2}>
//               Delivery Location
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={8}>
//             <WSTextField
//               control={control}
//               id="location"
//               name="location"
//               rules={{ required: true }}
//               label=""
//             />
//           </Grid>
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color={"GrayText"} mt={2}>
//               Delivery Location
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <Typography variant="body2" color={"GrayText"} mt={2}>
//               : Flat No. 202, Green Heights Apartments, Sector 45, Gurugram,
//               Haryana – 122003
//             </Typography>
//           </Grid>
//         </Grid>
//       </Paper>
//       <Grid item xs={12} sm={6} mt={3}>
//         <Paper
//           elevation={0}
//           style={{
//             paddingLeft: 20,
//             paddingRight: 20,
//             marginTop: 0,
//             paddingBottom: 25,
//             borderRadius: "8px",
//             height: "19rem",
//           }}
//         >
//           <Grid container spacing={2} mt={0}>
//             <Grid item sm={12} xs={12}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//                 Payment Information
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color={"GrayText"} mt={2}>
//                 Payment Status
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body2" color={"GrayText"} mt={2}>
//                 : Paid
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color={"GrayText"} mt={2}>
//                 Order Price
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body2" color={"GrayText"} mt={2}>
//                 : 480/-
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color={"GrayText"} mt={2}>
//                 Delivery Price
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body2" color={"GrayText"} mt={2}>
//                 : 80/-
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color={"GrayText"} mt={2}>
//                 Cash or Online
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body2" color={"GrayText"} mt={2}>
//                 : Cash
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color={"GrayText"} mt={2}>
//                 Invoice
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body2" style={{ color: "#098963" }} mt={2}>
//                 : Download
//               </Typography>
//             </Grid>
//           </Grid>
//         </Paper>
//       </Grid>
//       <Paper
//         elevation={0}
//         style={{
//           paddingLeft: 20,
//           paddingRight: 20,
//           marginTop: 40,
//           paddingBottom: 25,
//           borderRadius: "8px",
//         }}
//       >
//         <Grid container spacing={2}>
//           <Grid item sm={12} xs={12}>
//             <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//               Report Status
//             </Typography>
//           </Grid>
//           <Grid item xs={12}>
//             <Divider />
//           </Grid>{" "}
//           <Grid item sm={2} xs={12}>
//             <Typography variant="body2" color={"GrayText"} mt={4}>
//               Pharmacy Report (Bill) Status
//             </Typography>
//           </Grid>
//           <Grid item sm={6} xs={12}>
//             <WSFileUpload
//               name="bill"
//               label=""
//               control={control}
//               rules={{ required: false }}
//               acceptFileTypes=".jpg,.jpeg,.png"
//               maxFileSizeMB={2}
//               //  defaultValue={defaultImg}
//               id={"bill"}
//               image={true}
//               align="Start"
//               isToolTipImg={false}
//               multiple={true}
//             />
//           </Grid>
//         </Grid>
//       </Paper>
//       <SwipeableDrawerForm
//         anchor="right"
//         title={"Order Information"}
//         openForm={open}
//         isEdit={true}
//         formComponent={
//           <form onSubmit={handleSubmit(handleOrderData)}>{formComponent}</form>
//         }
//         onClose={() => {
//           reset();
//           setOpen(false);
//           setFormComponent(null);
//         }}
//       />
//     </>
//   );
// });








// import React, { useEffect, useState, useCallback, useMemo } from "react";
// import { useForm } from "react-hook-form";
// import { useNavigate, useParams } from "react-router-dom";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import WSBackButton from "../../../Components/BackButton/BackButton";
// import { Box, Divider, Grid, Paper, Typography } from "@mui/material";
// import WSHorizontalTimeline from "../../../Components/Timeline/WSHorizontalTimeLine";
// import WSSelectField from "../../../Components/Select/WSSelect";
// import config from "../../../Config/clientConfig.json";
// import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
// import WSTextField from "../../../Components/TextBox/WSTextBox";
// import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";
// import PrescriptionDrawer from "./PrescriptionDrawer";
// import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";



// interface PrescriptionOrderData {
//   timeline: {
//     orderPlaced: string;
//     deliveryAssigned: string | null;
//     orderShipped: string | null;
//     delivered: string | null;
//     status: string | null;
//     technician: string;
//   };
//   patient: {
//     username: string;
//     contactNumber: string;
//     address: string;
//   };
//   orderInfo: {
//     totalItems: number;
//     subtotal: number;
//     deliveryFee: number;
//     payment: string | null;
//     itemsName: string;
//     imageUrls: string[];
//   };
//   uplodedPrescrption: string | null;
//   report: string | null;
//   deliveryDetails: {
//     technicianName: string;
//     technicianStatus: string;
//     deliveryStatus: string;
//     receivedDateTime: string | null;
//     locationUrl: string | null;
//     deliveryAddress: string | null;
//   };
//   paymentInfo: {
//     paymentStatus: string;
//     orderPrice: number;
//     deliveryPrice: number;
//     paymentMode: string | null;
//     invoiceUrl: string;
//   };
// }

// interface ApiResponse {
//   status: boolean;
//   message: string;
//   data: PrescriptionOrderData;
// }

// interface FormData {
//   status: string;
//   action: string;
//   assigned: string;
//   collected: string;
//   test: string;
//   location: string;
//   bill: FileList | null;
//   items: string;
//   total: string;
//   deliveryFee: string;
//   fee: string;
//   medicineName: string;
//   no: string;
//   quant: string;
// }

// export const PrescriptionOrderDetails: React.FC = () => {
//   const { control, register, handleSubmit, setValue, reset } = useForm<FormData>({
//     defaultValues: {
//       status: "",
//       action: "",
//       assigned: "",
//       collected: "",
//       test: "",
//       location: "",
//       bill: null
//     }
//   });

//   const navigate = useNavigate();
//   const params = useParams<{ id: string }>();
//   const id = params?.id;

//   console.log("🆔 Order ID:", id);

//   const [orderData, setOrderData] = useState<PrescriptionOrderData | null>(null);
//   const [loading, setLoading] = useState<boolean>(true);
//   const [openDrawer, setOpenDrawer] = useState(false);
//   const [formComponent, setFormComponent] = useState<any>(null);

//   const fetchOrderData = useCallback(async () => {
//     if (!id) {
//       console.error("❌ No order ID");
//       setLoading(false);
//       return;
//     }

//     console.log("🔄 Fetching ID:", id);

//     try {
//       setLoading(true);
//       const response = await callAPI(
//         `pharmacy/PrescriptionOrder/order-details/${id}`, 
//         Method.GET
//       );

//       console.log("the response is ",response)

//       if (response.status && response.data) {
//         setOrderData(response.data);
//         console.log("✅ OrderData set:", response.data);
        
//         setValue("status", response.data.timeline.status || "");
//         setValue("assigned", response.data.deliveryDetails.technicianStatus || "Pending");
//         setValue("collected", response.data.deliveryDetails.deliveryStatus || "Pending");
//         setValue("test", response.data.deliveryDetails.technicianName || "");
//         setValue("location", response.data.deliveryDetails.deliveryAddress || response.data.patient.address || "");

//         setValue("items", response.data.orderInfo.totalItems.toString());
//         setValue("total", response.data.orderInfo.subtotal.toString());
//         setValue("deliveryFee", response.data.orderInfo.deliveryFee.toString());
//         setValue("fee", response.data.orderInfo.payment || "Cash");
//         setValue("medicineName", response.data.orderInfo.itemsName);
//         setValue("no", "1");
//         setValue("quant", "1");
//       } else {
//         console.error("❌ Invalid response:", response);
//       }
//     } catch (error) {
//       console.error("💥 Error:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, [id, setValue]);

//   useEffect(() => {
//     fetchOrderData();
//   }, [fetchOrderData]);

//   const timelineSteps = useMemo(() => {
//     const timelineData = orderData?.timeline;
//     const currentStatus = timelineData?.status?.toLowerCase() || "pending";
    
//     console.log("🔍 TIMELINE DEBUG:", {
//       status: timelineData?.status,
//       orderPlaced: !!timelineData?.orderPlaced,
//       deliveryAssigned: !!timelineData?.deliveryAssigned,
//       orderShipped: !!timelineData?.orderShipped,
//       delivered: !!timelineData?.delivered
//     });
  
//     // ✅ FIXED: If status = "delivered/completed", ALL PREVIOUS STEPS = GREEN
//     const isDelivered = currentStatus.includes("delivered") || currentStatus.includes("completed");
//     const isShipped = currentStatus.includes("shipped") || isDelivered;
//     const isAssigned = currentStatus.includes("assigned") || isShipped;
    
//     return [
//       { 
//         label: "Order Placed", 
//         completed: !!timelineData?.orderPlaced || isAssigned,  // ✅ Always true if assigned+
//         icon: <WSIcons.FiPackage /> 
//       },
//       { 
//         label: "Delivery Assigned", 
//         completed: !!timelineData?.deliveryAssigned || isAssigned,  // ✅ FIXED: Shows GREEN
//         icon: <WSIcons.TbUserSquareRounded /> 
//       },
//       { 
//         label: "Order Shipped", 
//         completed: !!timelineData?.orderShipped || isShipped,  // ✅ FIXED: Shows GREEN  
//         icon: <WSIcons.RiRidingLine /> 
//       },
//       { 
//         label: "Delivered", 
//         completed: !!timelineData?.delivered || isDelivered,  // ✅ Current status
//         icon: <WSIcons.BsArrowUpSquare /> 
//       },
//     ];
//   }, [orderData]);

//   const handleOrderData = async (data: FormData) => {
//     try {
//       const formData = new FormData();
//       Object.entries(data).forEach(([key, value]) => {
//         if (value instanceof FileList && value.length > 0) {
//          Array.from(value).forEach(file => formData.append(key, file));
//         } else if (value !== null && value !== undefined && value !== "") {
//           formData.append(key, value.toString());
//         }
//       });

//       const response = await callAPI(
//         `pharmacy/PrescriptionOrder/order-details/${id}`, 
//         Method.PUT,
//         formData
//       );
//       console.log("thebresponse data",response)

//       if (response.status) {
//         alert("Order updated successfully!");
//         fetchOrderData();
//       }
//     } catch (error) {
//       console.error("Update failed:", error);
//       alert("Failed to update order");
//     }
//   };

//   const handleOrderInfo = () => {
//     const form = (
//       <PrescriptionDrawer
//         id="emailAdd"
//         control={control}
//         register={register}
//         reset={reset}
//         setValue={setValue}
//         onCancel={() => {
//           reset();
//           setOpenDrawer(false);
//           setFormComponent(null);
//         }}
//       />
//     );
//     setFormComponent(form);
//     setTimeout(() => setOpenDrawer(true), 10);
//   };

//   useEffect(() => {
//     breadCrumbsStore.updateBreadCrumbs([
//       { "Orders": "pharmacy-orders/list" },
//       { [`Order Details #${id?.slice(-6) || ""}`]: "" }
//     ]);
//   }, [id]);

//   if (loading) {
//     return (
//       <>
//         <WSBackButton id="btnScheduleBack" url="/pharmacy-orders/list" />
//         <Paper style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
//          <Typography>Loading order details...</Typography>
//         </Paper>
//       </>
//     );
//   }

//   if (!orderData) {
//     return (
//       <>
//         <WSBackButton id="btnScheduleBack" url="/pharmacy-orders/list" />
//         <Paper style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
//          <Typography color="error">Order not found</Typography>
//         </Paper>
//       </>
//     );
//   }

//   return (
//     <form onSubmit={handleSubmit(handleOrderData)}>
//       <WSBackButton id="btnScheduleBack" url="/pharmacy-orders/list" />

//       {/* Timeline */}
//       <Paper elevation={0} style={{ padding: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
//         <Grid container spacing={2}>
//           <Grid item xs={12}>
//             <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Order Timeline</Typography>
//           </Grid>
//           <Grid item xs={12}>
//             <WSHorizontalTimeline steps={timelineSteps} />
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Order Summary */}
//       <Paper elevation={0} style={{ padding: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
//         <Grid container spacing={2} mt={2}>
//           <Grid item sm={4} xs={12}><Typography>Order ID</Typography></Grid>
//           <Grid item sm={4} xs={12}><Typography>Technician Status</Typography></Grid>
//           <Grid item sm={2} xs={12}><Typography>Delivery Status</Typography></Grid>
//           <Grid item xs={12}><Divider style={{ marginTop: 10 }} /></Grid>
          
//           <Grid item sm={4} xs={12}>
//             <Typography>#HC{id?.slice(-6).toUpperCase()}</Typography>
//           </Grid>
//           <Grid item sm={4} xs={12}>
//             <WSTextField
//              control={control}
//               id="technicianStatus"
//               name="technicianStatus"
//               rules={{ required: true }}
//               label=""
//               defaultValue={orderData.deliveryDetails.technicianStatus}
             
//               sx={{ width: "131px" }}
//             />
//           </Grid>
//           <Grid item sm={2} xs={12}>
//             <WSTextField
//                control={control}
//               id="deliveryStatus"
//               name="deliveryStatus"
//               rules={{ required: true }}
//               label=""
//               defaultValue={orderData.deliveryDetails.deliveryStatus}
//               sx={{ width: "131px" }}
//             />
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <Grid sx={{
//               display: "flex", alignItems: "center", gap: 1, px: 2, py: 1,
//               bgcolor: "#DDF6EC", borderRadius: 2, minWidth: 160, justifyContent: "center"
//             }}>
//               <Grid sx={{ color: "#33B78E", fontSize: 20 }}>
//                 <WSIcons.VisibilityIcon />
//               </Grid>
//               <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#1E8A67" }}>
//                 Delivery Report
//               </Typography>
//             </Grid>
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Patient & Order Info */}
//       <Grid container spacing={2} mt={2}>
//         <Grid item xs={12} sm={6}>
//           <Paper elevation={0} style={{ padding: 20, paddingBottom: 25, borderRadius: "8px", height: "19rem" }}>
//             <Grid container spacing={2}>
//               <Grid item xs={12}>
//                 <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Patient Information</Typography>
//               </Grid>
//               <Grid item xs={12} sm={3}><Typography variant="body2" color="GrayText">Patient Name</Typography></Grid>
//               <Grid item xs={12} sm={9}><Typography>: {orderData.patient.username}</Typography></Grid>
              
//               <Grid item xs={12} sm={3}><Typography variant="body2" color="GrayText">Contact Number</Typography></Grid>
//               <Grid item xs={12} sm={9}><Typography>: {orderData.patient.contactNumber}</Typography></Grid>
              
//               <Grid item xs={12} sm={3}><Typography variant="body2" color="GrayText">Address</Typography></Grid>
//               <Grid item xs={12} sm={9}><Typography>: {orderData.patient.address}</Typography></Grid>
//             </Grid>
//           </Paper>
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <Paper elevation={0} style={{ padding: 20, paddingBottom: 25, borderRadius: "8px", height: "19rem" }}>
//             <Grid container spacing={2}>
//               <Grid item sm={11} xs={12}>
//                 <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Order Information</Typography>
//               </Grid>
//               {/* <Grid item sm={1} xs={12}>
//                 <WSIcons.FaRegEdit onClick={handleOrderInfo} style={{ cursor: 'pointer' }} />
//               </Grid> */}
              
//               <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Total Items</Typography></Grid>
//               <Grid item xs={12} sm={8}><Typography>: {orderData.orderInfo.totalItems}</Typography></Grid>
              
//               <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Sub Total</Typography></Grid>
//               <Grid item xs={12} sm={8}><Typography>: ₹{orderData.orderInfo.subtotal}</Typography></Grid>
              
//               <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Delivery Fee</Typography></Grid>
//               <Grid item xs={12} sm={8}><Typography>: ₹{orderData.orderInfo.deliveryFee}</Typography></Grid>
              
//               <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Payment</Typography></Grid>
//               <Grid item xs={12} sm={8}><Typography>: {orderData.orderInfo.payment }</Typography></Grid>
              
//               <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Medicine Name</Typography></Grid>
//               <Grid item xs={12} sm={8}><Typography>: {orderData.orderInfo.itemsName}</Typography></Grid>
//             </Grid>
//           </Paper>
//         </Grid>
//       </Grid>

//       {/* ✅ Prescription Image - DISPLAY ONLY FROM API */}
//       <Paper elevation={0} style={{ padding: 20, marginTop: 40, paddingBottom: 25, borderRadius: "8px" }}>
//   <Grid container spacing={2}>
//     <Grid item xs={12}>
//       <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Prescription Image</Typography>
//     </Grid>
//     <Grid item xs={12}><Divider /></Grid>
//     <Grid item xs={12}>
//       {orderData?.orderInfo.imageUrls && orderData.orderInfo.imageUrls.length > 0 ? (
//         <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
//           {/* ✅ FIXED: Correct image URL construction */}
//           <img
//             src={orderData.orderInfo.imageUrls[0].startsWith('http') 
//               ? orderData.orderInfo.imageUrls[0] 
//               : `${window.location.origin}${orderData.orderInfo.imageUrls[0]}`}
//             alt="Prescription"
//             style={{
//               maxWidth: '100%',
//               maxHeight: '400px',
//               objectFit: 'contain',
//               borderRadius: '8px',
//               boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
//             }}
//             onLoad={() => console.log('🟢 Image LOADED!')}
//             onError={(e) => {
//               console.error('🔴 Image ERROR:', orderData.orderInfo.imageUrls[0]);
//               (e.target as HTMLImageElement).style.display = 'none';
//               (e.target as HTMLImageElement).parentElement!.innerHTML += 
//                 '<Typography color="error" sx={{textAlign: "center", mt: 2}}>Image not found on server</Typography>';
//             }}
//           />
//           <Typography variant="body2" color="textSecondary">
//             Prescription Image (from order)
//           </Typography>
//         </Box>
//       ) : (
//         <Box sx={{ 
//           display: 'flex', 
//           alignItems: 'center', 
//           justifyContent: 'center', 
//           height: '300px', 
//           border: '2px dashed #ccc', 
//           borderRadius: '8px',
//           bgcolor: '#f5f5f5'
//         }}>
//           <Typography color="textSecondary" sx={{ textAlign: 'center' }}>
//             No prescription image available
//           </Typography>
//         </Box>
//       )}
//     </Grid>
//   </Grid>
// </Paper>


//       {/* ✅ FIXED Delivery Details - Clean Grid Structure */}
//       <Paper elevation={0} style={{ padding: 20, marginTop: 40, paddingBottom: 25, borderRadius: "8px" }}>
//         <Grid container spacing={2}>
//           <Grid item xs={12}><Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Delivery Details</Typography></Grid>
//           <Grid item xs={12}><Divider /></Grid>
          
//           {/* ✅ Technician */}
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color="GrayText" mt={2}>
//               Assigned Technician:
//             </Typography>
//           </Grid>
//           {/* <Grid item xs={12} sm={8}><Typography variant="body2" color="GrayText" mt={2}>#{orderData.deliveryDetails.technicianName}</Typography></Grid> */}
//   <Grid item xs={12} sm={8}>
//             <WSTextField
//               control={control}
//               id="technicianName"
//               name="technicianName"
//               rules={{ required: true }}
//               label=""
//               defaultValue={orderData.deliveryDetails.technicianName}
//               sx={{ width: "200px" }}
//             />
//           </Grid>
//           {/* ✅ Technician Status */}
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color="GrayText" mt={2}>
//               Technician Status:
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={8}>
//              <WSTextField
//               control={control}
//               id="technicianStatus"
//               name="technicianStatus"
//               rules={{ required: true }}
//               label=""
//               defaultValue={orderData.deliveryDetails.technicianStatus}
//               sx={{ width: "200px" }}
//             />
//           </Grid>
          
//           {/* ✅ Delivery Status */}
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color="GrayText" mt={2}>
//               Delivery Status:
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={8}>
//             <WSTextField
//               control={control}
//               id="deliveryStatus"
//               name="deliveryStatus"
//               rules={{ required: true }}
//               label=""
//               defaultValue={orderData.deliveryDetails.deliveryStatus}
//               sx={{ width: "200px" }}
//             />
//           </Grid>
          
//           {/* ✅ Order ID */}
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color="GrayText" mt={2}>Order ID</Typography>
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <Typography variant="body2" mt={2}>#{id?.slice(-6).toUpperCase()}</Typography> 
//           </Grid>
          
//           {/* ✅ Order Date */}
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color="GrayText" mt={2}>Order Date</Typography>
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <Typography variant="body2" mt={2}>
//               {new Date(orderData!.timeline.orderPlaced).toLocaleString()} 
//             </Typography>
//           </Grid>
          
//           {/* ✅ Delivery Location */}
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color="GrayText" mt={2}>Delivery Location</Typography>
//           </Grid>
//           <Grid item xs={12} sm={8}>
//             <WSTextField
//               control={control}
//               id="location"
//               name="location"
//               rules={{ required: true }}
//               label=""
//             />
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* ✅ Payment Information */}
//       <Grid item xs={12} sm={6} mt={3}>
//         <Paper elevation={0} style={{ padding: 20, paddingBottom: 25, borderRadius: "8px", height: "19rem" }}>
//           <Grid container spacing={2}>
//             <Grid item xs={12}><Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Payment Information</Typography></Grid>
//             <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Payment Status</Typography></Grid>
//             <Grid item xs={12} sm={8}><Typography>: {orderData.paymentInfo.paymentStatus}</Typography></Grid>
            
//             <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Order Price</Typography></Grid>
//             <Grid item xs={12} sm={8}><Typography>: ₹{orderData.paymentInfo.orderPrice}</Typography></Grid>
            
//             <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Delivery Price</Typography></Grid>
//             <Grid item xs={12} sm={8}><Typography>: ₹{orderData.paymentInfo.deliveryPrice}</Typography></Grid>
            
//             <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Cash or Online</Typography></Grid>
//             <Grid item xs={12} sm={8}><Typography>: {orderData.paymentInfo.paymentMode || 'Cash'}</Typography></Grid>
            
//             <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Invoice</Typography></Grid>
//             <Grid item xs={12} sm={8}>
//               <Typography style={{ color: "#098963" }}>Download</Typography>
//             </Grid>
//           </Grid>
//         </Paper>
//       </Grid>

//       {/* ✅ Report Status */}
//       <Paper elevation={0} style={{ padding: 20, marginTop: 40, paddingBottom: 25, borderRadius: "8px" }}>
//         <Grid container spacing={2}>
//           <Grid item xs={12}><Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Report Status</Typography></Grid>
//           <Grid item xs={12}><Divider /></Grid>
//           <Grid item sm={2} xs={12}><Typography variant="body2" color="GrayText" mt={4}>Pharmacy Report (Bill) Status</Typography></Grid>
//           <Grid item sm={10} xs={12}>
//             <WSFileUpload
//               name="bill"
//               label=""
//               control={control as any}
//               rules={{ required: false }}
//               acceptFileTypes=".jpg,.jpeg,.png"
//               maxFileSizeMB={2}
//               id="bill"
//               image={true}
//               align="Start"
//               isToolTipImg={false}
//               multiple={true}
//             />
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* ✅ Drawer for Order Info Edit */}
//       <SwipeableDrawerForm
//         anchor="right"
//         title="Order Information"
//         openForm={openDrawer}
//         isEdit={true}
//         formComponent={<form onSubmit={handleSubmit(handleOrderData)}>{formComponent}</form>}
//         onClose={() => {
//           reset();
//           setOpenDrawer(false);
//           setFormComponent(null);
//         }}
//       />

//       {/* ✅ Hidden Submit Button */}
//       <button type="submit" style={{ display: 'none' }} />
//     </form>
//   );
// };

// export default PrescriptionOrderDetails;






// import React, { useEffect, useState, useCallback, useMemo } from "react";
// import { useForm } from "react-hook-form";
// import { useNavigate, useParams } from "react-router-dom";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import WSBackButton from "../../../Components/BackButton/BackButton";
// import { Alert, Box, Divider, Grid, Paper, Typography } from "@mui/material";
// import WSHorizontalTimeline from "../../../Components/Timeline/WSHorizontalTimeLine";
// import WSSelectField from "../../../Components/Select/WSSelect";
// import config from "../../../Config/clientConfig.json";
// import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
// import WSTextField from "../../../Components/TextBox/WSTextBox";
// import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";
// import PrescriptionDrawer from "./PrescriptionDrawer";
// import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
// import { FiSave, FiCheckCircle } from 'react-icons/fi';
// import { PrescriptionOrderInvoiceReport } from "./PrescriptionInvoice"; 


// interface PrescriptionOrderData {
//   timeline: {
//     orderPlaced: string;
//     deliveryAssigned: string | null;
//     orderShipped: string | null;
//     delivered: string | null;
//     status: string | null;
//     technician: string;
//   };
//   patient: {
//     username: string;
//     contactNumber: string;
//     address: string;
//   };
//   orderInfo: {
//     totalItems: number;
//     subtotal: number;
//     deliveryFee: number;
//     payment: string | null;
//     itemsName: string;
//     imageUrls: string[];
//   };
//   uplodedPrescrption: string | null;
//   report: string | null;
//   deliveryDetails: {
//     technicianName: string;
//     technicianStatus: string;
//     deliveryStatus: string;
//     receivedDateTime: string | null;
//     locationUrl: string | null;
//     deliveryAddress: string | null;
//   };
//   paymentInfo: {
//     paymentStatus: string;
//     orderPrice: number;
//     deliveryPrice: number;
//     paymentMode: string | null;
//     invoiceUrl: string;
//   };
// }

// interface ApiResponse {
//   status: boolean;
//   message: string;
//   data: PrescriptionOrderData;
// }

// interface FormData {
//   status: string;
//   action: string;
//   assigned: string;
//   collected: string;
//   test: string;
//   location: string;
//   bill: FileList | null;
//   items: string;
//   total: string;
//   deliveryFee: string;
//   fee: string;
//   medicineName: string;
//   no: string;
//   quant: string;
//   technicianName: string;
//   technicianStatus: string;
//   deliveryStatus: string;
// }

// export const PrescriptionOrderDetails: React.FC = () => {
//   const { 
//     control, 
//     register, 
//     handleSubmit, 
//     setValue, 
//     reset, 
//     getValues, 
//     resetField 
//   } = useForm<FormData>({
//     defaultValues: {
//       status: "",
//       action: "",
//       assigned: "",
//       collected: "",
//       test: "",
//       location: "",
//       bill: null,
//       technicianName: "",
//       technicianStatus: "",
//       deliveryStatus: ""
//     }
//   });

//   const navigate = useNavigate();
//   const params = useParams<{ id: string }>();
//   const id = params?.id;

//   console.log("🆔 Order ID:", id);

//   const [orderData, setOrderData] = useState<PrescriptionOrderData | null>(null);
//   const [loading, setLoading] = useState<boolean>(true);
//   const [openDrawer, setOpenDrawer] = useState(false);
//   const [formComponent, setFormComponent] = useState<any>(null);
//   // ✅ NEW STATES FOR SAVE BUTTON
//   const [isUploading, setIsUploading] = useState(false);
//   const [showUploadSuccess, setShowUploadSuccess] = useState(false);
//   // Add these states after your existing state declarations
// const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);


//   const fetchOrderData = useCallback(async () => {
//     if (!id) {
//       console.error("❌ No order ID");
//       setLoading(false);
//       return;
//     }

//     console.log("🔄 Fetching ID:", id);

//     try {
//       setLoading(true);
//       const response = await callAPI(
//         `pharmacy/PrescriptionOrder/order-details/${id}`, 
//         Method.GET
//       );

//       console.log("the response is ",response)

//       if (response.status && response.data) {
//         setOrderData(response.data);
//         console.log("✅ OrderData set:", response.data);
        
//         setValue("status", response.data.timeline.status || "");
//         setValue("assigned", response.data.deliveryDetails.technicianStatus || "Pending");
//         setValue("collected", response.data.deliveryDetails.deliveryStatus || "Pending");
//         setValue("test", response.data.deliveryDetails.technicianName || "");
//         setValue("location", response.data.deliveryDetails.deliveryAddress || response.data.patient.address || "");

//         setValue("items", response.data.orderInfo.totalItems.toString());
//         setValue("total", response.data.orderInfo.subtotal.toString());
//         setValue("deliveryFee", response.data.orderInfo.deliveryFee.toString());
//         setValue("fee", response.data.orderInfo.payment || "Cash");
//         setValue("medicineName", response.data.orderInfo.itemsName);
//         setValue("no", "1");
//         setValue("quant", "1");
//         setValue("technicianName", response.data.deliveryDetails.technicianName);
//         setValue("technicianStatus", response.data.deliveryDetails.technicianStatus);
//         setValue("deliveryStatus", response.data.deliveryDetails.deliveryStatus);
//       } else {
//         console.error("❌ Invalid response:", response);
//       }
//     } catch (error) {
//       console.error("💥 Error:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, [id, setValue]);

//   useEffect(() => {
//     fetchOrderData();
//   }, [fetchOrderData]);

//   // ✅ NEW: Standalone Invoice Upload Handler
//   const handleInvoiceUpload = useCallback(async () => {
//     try {
//       const billValue = getValues('bill');
//       if (!billValue || billValue.length === 0) {
//         alert('Please select a bill/invoice file first');
//         return;
//       }

//       setIsUploading(true);
//       setShowUploadSuccess(false);
      
//       const invoiceFormData = new FormData();
//       Array.from(billValue).forEach(file => {
//         invoiceFormData.append('invoice', file);
//       });

//       console.log('📤 Standalone invoice upload:', id);
      
//       const response = await callAPI(
//         `pharmacy/Ph_Order_/${id}/upload-invoice`,
//         Method.POST,
//         invoiceFormData
//       );

//       console.log('✅ Invoice upload response:', response);

//       if (response.status) {
//         setShowUploadSuccess(true);
//         setTimeout(() => setShowUploadSuccess(false), 3000);
//         fetchOrderData(); // Refresh order data to show invoice URL
//         resetField('bill'); // Clear file input
//       } else {
//         alert('Failed to upload invoice: ' + (response.message || 'Unknown error'));
//       }
//     } catch (error) {
//       console.error('💥 Invoice upload error:', error);
//       alert('Upload failed. Please try again.');
//     } finally {
//       setIsUploading(false);
//     }
//   }, [id, getValues, resetField, fetchOrderData]);

//   const timelineSteps = useMemo(() => {
//     const timelineData = orderData?.timeline;
//     const currentStatus = timelineData?.status?.toLowerCase() || "pending";
    
//     console.log("🔍 TIMELINE DEBUG:", {
//       status: timelineData?.status,
//       orderPlaced: !!timelineData?.orderPlaced,
//       deliveryAssigned: !!timelineData?.deliveryAssigned,
//       orderShipped: !!timelineData?.orderShipped,
//       delivered: !!timelineData?.delivered
//     });
  
//     const isDelivered = currentStatus.includes("delivered") || currentStatus.includes("completed");
//     const isShipped = currentStatus.includes("shipped") || isDelivered;
//     const isAssigned = currentStatus.includes("assigned") || isShipped;
    
//     return [
//       { 
//         label: "Order Placed", 
//         completed: !!timelineData?.orderPlaced || isAssigned,
//         icon: <WSIcons.FiPackage /> 
//       },
//       { 
//         label: "Delivery Assigned", 
//         completed: !!timelineData?.deliveryAssigned || isAssigned,
//         icon: <WSIcons.TbUserSquareRounded /> 
//       },
//       { 
//         label: "Order Shipped", 
//         completed: !!timelineData?.orderShipped || isShipped,
//         icon: <WSIcons.RiRidingLine /> 
//       },
//       { 
//         label: "Delivered", 
//         completed: !!timelineData?.delivered || isDelivered,
//         icon: <WSIcons.BsArrowUpSquare /> 
//       },
//     ];
//   }, [orderData]);

//   const handleOrderData = async (data: FormData) => {
//     try {
//       // ✅ Handle Invoice Upload separately using the specific API
//       if (data.bill && data.bill.length > 0) {
//         const invoiceFormData = new FormData();
//         Array.from(data.bill).forEach(file => {
//           invoiceFormData.append('invoice', file);
//         });
        
//         console.log('📤 Uploading invoice for order:', id);
        
//         const invoiceResponse = await callAPI(
//           `pharmacy/Ph_Order_/${id}/upload-invoice`,
//           Method.POST,
//           invoiceFormData
//         );
        
//         console.log('📄 Invoice upload response:', invoiceResponse);
        
//         if (!invoiceResponse.status) {
//           alert('Failed to upload invoice');
//           return;
//         }
//       }

//       // ✅ Handle other form data updates
//       const updateFormData = new FormData();
//       const fieldsToUpdate = ['status', 'assigned', 'collected', 'test', 'location', 'items', 'total', 'deliveryFee', 'fee', 'medicineName', 'no', 'quant', 'technicianName', 'technicianStatus', 'deliveryStatus'];
      
//       fieldsToUpdate.forEach(key => {
//         const value = data[key as keyof FormData];
//         if (value !== null && value !== undefined && value !== "") {
//           updateFormData.append(key, value.toString());
//         }
//       });

//       if (updateFormData.entries().next().done === false) {
//         const updateResponse = await callAPI(
//           `pharmacy/PrescriptionOrder/order-details/${id}`, 
//           Method.PUT,
//           updateFormData
//         );
//         console.log('🔄 Order update response:', updateResponse);
//       }

//       alert("Order and invoice updated successfully!");
//       fetchOrderData();
      
//     } catch (error) {
//       console.error("💥 Update failed:", error);
//       alert("Failed to update order/invoice");
//     }
//   };

//   const handleOrderInfo = () => {
//     const form = (
//       <PrescriptionDrawer
//         id="emailAdd"
//         control={control}
//         register={register}
//         reset={reset}
//         setValue={setValue}
//         onCancel={() => {
//           reset();
//           setOpenDrawer(false);
//           setFormComponent(null);
//         }}
//       />
//     );
//     setFormComponent(form);
//     setTimeout(() => setOpenDrawer(true), 10);
//   };

//   useEffect(() => {
//     breadCrumbsStore.updateBreadCrumbs([
//       { "Orders": "pharmacy-orders/list" },
//       { [`Order Details #${id?.slice(-6) || ""}`]: "" }
//     ]);
//   }, [id]);

//   if (loading) {
//     return (
//       <>
//         <WSBackButton id="btnScheduleBack" url="/pharmacy-orders/list" />
//         <Paper style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
//           <Typography>Loading order details...</Typography>
//         </Paper>
//       </>
//     );
//   }

//   if (!orderData) {
//     return (
//       <>
//         <WSBackButton id="btnScheduleBack" url="/pharmacy-orders/list" />
//         <Paper style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
//           <Typography color="error">Order not found</Typography>
//         </Paper>
//       </>
//     );
//   }

//   return (
//     <form onSubmit={handleSubmit(handleOrderData)}>
//       <WSBackButton id="btnScheduleBack" url="/pharmacy-orders/list" />

//       {/* Timeline */}
//       <Paper elevation={0} style={{ padding: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
//         <Grid container spacing={2}>
//           <Grid item xs={12}>
//             <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Order Timeline</Typography>
//           </Grid>
//           <Grid item xs={12}>
//             <WSHorizontalTimeline steps={timelineSteps} />
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Order Summary */}
//       <Paper elevation={0} style={{ padding: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
//         <Grid container spacing={2} mt={2}>
//           <Grid item sm={4} xs={12}><Typography>Order ID</Typography></Grid>
//           <Grid item sm={4} xs={12}><Typography>Technician Status</Typography></Grid>
//           <Grid item sm={2} xs={12}><Typography>Delivery Status</Typography></Grid>
//           <Grid item xs={12}><Divider style={{ marginTop: 10 }} /></Grid>
          
//           <Grid item sm={4} xs={12}>
//             <Typography>#HC{id?.slice(-6).toUpperCase()}</Typography>
//           </Grid>
//           <Grid item sm={4} xs={12}>
//             <WSTextField
//               control={control}
//               id="technicianStatus"
//               name="technicianStatus"
//               rules={{ required: true }}
//               label=""
//               defaultValue={orderData.deliveryDetails.technicianStatus}
//               sx={{ width: "131px" }}
//             />
//           </Grid>
//           <Grid item sm={2} xs={12}>
//             <WSTextField
//               control={control}
//               id="deliveryStatus"
//               name="deliveryStatus"
//               rules={{ required: true }}
//               label=""
//               defaultValue={orderData.deliveryDetails.deliveryStatus}
//               sx={{ width: "131px" }}
//             />
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <Grid sx={{
//               display: "flex", alignItems: "center", gap: 1, px: 2, py: 1,
//               bgcolor: "#DDF6EC", borderRadius: 2, minWidth: 160, justifyContent: "center"
//             }}>
//               <Grid sx={{ color: "#33B78E", fontSize: 20 }}>
//                 <WSIcons.VisibilityIcon />
//               </Grid>
//               <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#1E8A67" }}>
//                 Delivery Report
//               </Typography>
//             </Grid>
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Patient & Order Info */}
//       <Grid container spacing={2} mt={2}>
//         <Grid item xs={12} sm={6}>
//           <Paper elevation={0} style={{ padding: 20, paddingBottom: 25, borderRadius: "8px", height: "19rem" }}>
//             <Grid container spacing={2}>
//               <Grid item xs={12}>
//                 <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Patient Information</Typography>
//               </Grid>
//               <Grid item xs={12} sm={3}><Typography variant="body2" color="GrayText">Patient Name</Typography></Grid>
//               <Grid item xs={12} sm={9}><Typography>: {orderData.patient.username}</Typography></Grid>
              
//               <Grid item xs={12} sm={3}><Typography variant="body2" color="GrayText">Contact Number</Typography></Grid>
//               <Grid item xs={12} sm={9}><Typography>: {orderData.patient.contactNumber}</Typography></Grid>
              
//               <Grid item xs={12} sm={3}><Typography variant="body2" color="GrayText">Address</Typography></Grid>
//               <Grid item xs={12} sm={9}><Typography>: {orderData.patient.address}</Typography></Grid>
//             </Grid>
//           </Paper>
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <Paper elevation={0} style={{ padding: 20, paddingBottom: 25, borderRadius: "8px", height: "19rem" }}>
//             <Grid container spacing={2}>
//               <Grid item sm={11} xs={12}>
//                 <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Order Information</Typography>
//               </Grid>
              
//               <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Total Items</Typography></Grid>
//               <Grid item xs={12} sm={8}><Typography>: {orderData.orderInfo.totalItems}</Typography></Grid>
              
//               <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Sub Total</Typography></Grid>
//               <Grid item xs={12} sm={8}><Typography>: ₹{orderData.orderInfo.subtotal}</Typography></Grid>
              
//               <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Delivery Fee</Typography></Grid>
//               <Grid item xs={12} sm={8}><Typography>: ₹{orderData.orderInfo.deliveryFee}</Typography></Grid>
              
//               <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Payment</Typography></Grid>
//               <Grid item xs={12} sm={8}><Typography>: {orderData.orderInfo.payment}</Typography></Grid>
              
//               <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Medicine Name</Typography></Grid>
//               <Grid item xs={12} sm={8}><Typography>: {orderData.orderInfo.itemsName}</Typography></Grid>
//             </Grid>
//           </Paper>
//         </Grid>
//       </Grid>

//       {/* Prescription Image */}
//       <Paper elevation={0} style={{ padding: 20, marginTop: 40, paddingBottom: 25, borderRadius: "8px" }}>
//         <Grid container spacing={2}>
//           <Grid item xs={12}>
//             <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Prescription Image</Typography>
//           </Grid>
//           <Grid item xs={12}><Divider /></Grid>
//           <Grid item xs={12}>
//             {orderData?.orderInfo.imageUrls && orderData.orderInfo.imageUrls.length > 0 ? (
//               <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
//                 <img
//                   src={orderData.orderInfo.imageUrls[0].startsWith('http') 
//                     ? orderData.orderInfo.imageUrls[0] 
//                     : `${window.location.origin}${orderData.orderInfo.imageUrls[0]}`}
//                   alt="Prescription"
//                   style={{
//                     maxWidth: '100%',
//                     maxHeight: '400px',
//                     objectFit: 'contain',
//                     borderRadius: '8px',
//                     boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
//                   }}
//                   onLoad={() => console.log('🟢 Image LOADED!')}
//                   onError={(e) => {
//                     console.error('🔴 Image ERROR:', orderData.orderInfo.imageUrls[0]);
//                     (e.target as HTMLImageElement).style.display = 'none';
//                   }}
//                 />
//                 <Typography variant="body2" color="textSecondary">
//                   Prescription Image (from order)
//                 </Typography>
//               </Box>
//             ) : (
//               <Box sx={{ 
//                 display: 'flex', 
//                 alignItems: 'center', 
//                 justifyContent: 'center', 
//                 height: '300px', 
//                 border: '2px dashed #ccc', 
//                 borderRadius: '8px',
//                 bgcolor: '#f5f5f5'
//               }}>
//                 <Typography color="textSecondary" sx={{ textAlign: 'center' }}>
//                   No prescription image available
//                 </Typography>
//               </Box>
//             )}
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Delivery Details */}
//       <Paper elevation={0} style={{ padding: 20, marginTop: 40, paddingBottom: 25, borderRadius: "8px" }}>
//         <Grid container spacing={2}>
//           <Grid item xs={12}><Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Delivery Details</Typography></Grid>
//           <Grid item xs={12}><Divider /></Grid>
          
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color="GrayText" mt={2}>Assigned Technician:</Typography>
//           </Grid>
//           <Grid item xs={12} sm={8}>
//             <WSTextField
//               control={control}
//               id="technicianName"
//               name="technicianName"
//               rules={{ required: true }}
//               label=""
//               defaultValue={orderData.deliveryDetails.technicianName}
//               sx={{ width: "200px" }}
//             />
//           </Grid>
          
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color="GrayText" mt={2}>Technician Status:</Typography>
//           </Grid>
//           <Grid item xs={12} sm={8}>
//             <WSTextField
//               control={control}
//               id="technicianStatus"
//               name="technicianStatus"
//               rules={{ required: true }}
//               label=""
//               defaultValue={orderData.deliveryDetails.technicianStatus}
//               sx={{ width: "200px" }}
//             />
//           </Grid>
          
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color="GrayText" mt={2}>Delivery Status:</Typography>
//           </Grid>
//           <Grid item xs={12} sm={8}>
//             <WSTextField
//               control={control}
//               id="deliveryStatus"
//               name="deliveryStatus"
//               rules={{ required: true }}
//               label=""
//               defaultValue={orderData.deliveryDetails.deliveryStatus}
//               sx={{ width: "200px" }}
//             />
//           </Grid>
          
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color="GrayText" mt={2}>Order ID</Typography>
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <Typography variant="body2" mt={2}>#{id?.slice(-6).toUpperCase()}</Typography> 
//           </Grid>
          
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color="GrayText" mt={2}>Order Date</Typography>
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <Typography variant="body2" mt={2}>
//               {new Date(orderData!.timeline.orderPlaced).toLocaleString()} 
//             </Typography>
//           </Grid>
          
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color="GrayText" mt={2}>Delivery Location</Typography>
//           </Grid>
//           <Grid item xs={12} sm={8}>
//             <WSTextField
//               control={control}
//               id="location"
//               name="location"
//               rules={{ required: true }}
//               label=""
//             />
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Payment Information */}
//       <Grid item xs={12} sm={6} mt={3}>
//         <Paper elevation={0} style={{ padding: 20, paddingBottom: 25, borderRadius: "8px", height: "19rem" }}>
//           <Grid container spacing={2}>
//             <Grid item xs={12}><Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Payment Information</Typography></Grid>
//             <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Payment Status</Typography></Grid>
//             <Grid item xs={12} sm={8}><Typography>: {orderData.paymentInfo.paymentStatus}</Typography></Grid>
            
//             <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Order Price</Typography></Grid>
//             <Grid item xs={12} sm={8}><Typography>: ₹{orderData.paymentInfo.orderPrice}</Typography></Grid>
            
//             <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Delivery Price</Typography></Grid>
//             <Grid item xs={12} sm={8}><Typography>: ₹{orderData.paymentInfo.deliveryPrice}</Typography></Grid>
            
//             <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Cash or Online</Typography></Grid>
//             <Grid item xs={12} sm={8}><Typography>: {orderData.paymentInfo.paymentMode || 'Cash'}</Typography></Grid>
            
//             <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Invoice</Typography></Grid>
//             <Grid item xs={12} sm={8}>
//               {orderData.paymentInfo.invoiceUrl ? (
//                 <a 
//                   href={orderData.paymentInfo.invoiceUrl} 
//                   target="_blank" 
//                   rel="noopener noreferrer"
//                   style={{ color: "#098963", textDecoration: "underline" }}
//                 >
//                   Download
//                 </a>
//               ) : (
//                 <Typography style={{ color: "#098963" }}>No Invoice</Typography>
//               )}
//             </Grid>
//           </Grid>
//         </Paper>
//       </Grid>

//       {/* ✅ Report Status - WITH SAVE BUTTON */}
//       <Paper elevation={0} style={{ padding: 20, marginTop: 40, paddingBottom: 25, borderRadius: "8px" }}>
//         <Grid container spacing={2}>
//           <Grid item xs={12}><Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Report Status</Typography></Grid>
//           <Grid item xs={12}><Divider /></Grid>
          
//           <Grid item sm={2} xs={12}>
//             <Typography variant="body2" color="GrayText" mt={2}>Pharmacy Report (Bill)</Typography>
//           </Grid>
          
//           <Grid item sm={10} xs={12}>
//             <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, alignItems: { sm: 'center' }, mb: 2 }}>
//               {/* File Upload */}
//               <WSFileUpload
//                 name="bill"
//                 label="Upload Invoice (.jpg, .jpeg, .png, .pdf)"
//                 control={control as any}
//                 rules={{ required: false }}
//                 acceptFileTypes=".jpg,.jpeg,.png,.pdf"
//                 maxFileSizeMB={5}
//                 id="pharmacy-bill-upload"
//                 image={true}
//                 align="Start"
//                 isToolTipImg={false}
//                 multiple={false}
//                 disabled={isUploading}
//               />
              
//               {/* ✅ SAVE BUTTON */}
//               <button
//                 type="button"
//                 onClick={handleInvoiceUpload}
//                 disabled={isUploading || !getValues('bill')?.length}
//                 style={{
//                   padding: '12px 24px',
//                   backgroundColor: isUploading || !getValues('bill')?.length ? '#ccc' : '#098963',
//                   color: 'white',
//                   border: 'none',
//                   borderRadius: '6px',
//                   fontSize: '14px',
//                   fontWeight: 600,
//                   cursor: isUploading || !getValues('bill')?.length ? 'not-allowed' : 'pointer',
//                   minWidth: '140px',
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: 1,
//                   justifyContent: 'center',
//                   boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                 }}
//               >
//                 {isUploading ? (
//                   <>
//                     <div style={{ 
//                       width: 16, 
//                       height: 16, 
//                       border: '2px solid #fff', 
//                       borderTop: '2px solid transparent', 
//                       borderRadius: '50%', 
//                       animation: 'spin 1s linear infinite' 
//                     }} />
//                     Uploading...
//                   </>
//                 ) : (
//                   <>
//                     <FiSave style={{ fontSize: 16 }} />
//                     Save Invoice
//                   </>
//                 )}
//               </button>
//             </Box>

//             {/* Success Message */}
//             {showUploadSuccess && (
//               <Alert severity="success" sx={{ mb: 2 }}>
//                 ✅ Invoice uploaded successfully!
//               </Alert>
//             )}

//             {/* Existing Invoice Display */}
//             {orderData?.paymentInfo.invoiceUrl && (
//               <Box sx={{ p: 2, bgcolor: '#f0f8f0', borderRadius: 2, mt: 2 }}>
//                 <Typography variant="body2" color="success.main" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                   <FiCheckCircle style={{ fontSize: 20, color: '#4CAF50' }} /> 
//                   Invoice available: 
//                   <a 
//                     href={orderData.paymentInfo.invoiceUrl} 
//                     target="_blank" 
//                     rel="noopener noreferrer"
//                     style={{ color: '#098963', fontWeight: 600, textDecoration: 'underline' }}
//                   >
//                     View/Download
//                   </a>
//                 </Typography>
//               </Box>
//             )}
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Drawer for Order Info Edit */}
//       <SwipeableDrawerForm
//         anchor="right"
//         title="Order Information"
//         openForm={openDrawer}
//         isEdit={true}
//         formComponent={<form onSubmit={handleSubmit(handleOrderData)}>{formComponent}</form>}
//         onClose={() => {
//           reset();
//           setOpenDrawer(false);
//           setFormComponent(null);
//         }}
//       />

//       {/* Hidden Submit Button */}
//       <button type="submit" style={{ display: 'none' }} />
//     </form>
//   );
// };

// export default PrescriptionOrderDetails;







import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSBackButton from "../../../Components/BackButton/BackButton";
import { Box, Divider, Grid, Paper, Typography, Dialog, DialogContent, DialogTitle, IconButton, Button } from "@mui/material";
import WSHorizontalTimeline from "../../../Components/Timeline/WSHorizontalTimeLine";
import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
import config from "../../../Config/clientConfig.json";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";
import PrescriptionDrawer from "./PrescriptionDrawer";
import { PrescriptionOrderInvoiceReport } from "./PrescriptionInvoice"; 
import WSButton from "../../../Components/Button/WSButton";
import AddIcon from "@mui/icons-material/Add";
import configData from "../../../Config/config.json";


const imgUrl = configData.imgUrl;
const getCorrectedReportUrl = (reportUrl: string) => {
  return reportUrl.replace(/^UploadedImages\//, '');
};


interface Timeline {
  orderPlaced: string;
  deliveryAssigned: string | null;
  orderShipped: string | null;
  delivered: string | null;
  status: string | null;
  technician: string;
}

interface Patient {
  username: string;
  contactNumber: string;
  address: string;
}

interface OrderInfo {
  totalItems: number;
  subtotal: number;
  deliveryFee: number;
  payment: string | null;
  itemsName: string;
  imageUrls: string[];
}

interface DeliveryDetails {
  technicianName: string;
  technicianStatus: string;
  deliveryStatus: string;
  receivedDateTime: string | null;
  locationUrl: string | null;
  deliveryAddress: string | null;
}

interface PaymentInfo {
  paymentStatus: string;
  orderPrice: number;
  deliveryPrice: number;
  paymentMode: string | null;
  invoiceUrl: string;
}

interface OrderData {
  timeline: Timeline;
  patient: Patient;
  orderInfo: OrderInfo;
  uplodedPrescrption: string | null;
  report: string | null;
  deliveryDetails: DeliveryDetails;
  paymentInfo: PaymentInfo;
}

interface ApiResponse {
  status: boolean;
  message: string;
  data: OrderData;
}

interface BillUploadFormData {
  file: FileList | null;
}

export const PrescriptionOrderDetails: React.FC = React.memo(() => {
  const methods = useForm<BillUploadFormData>({
    defaultValues: {
      file: null
    }
  });
  
  const { control, handleSubmit, setValue, watch, formState } = methods;
  
  const navigate = useNavigate();
  const params = useParams<{ id: string }>();
  const id = params?.id;

  const [orderData, setOrderData] = useState<OrderData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>("");
  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
  const [billUploadSuccess, setBillUploadSuccess] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [formComponent, setFormComponent] = useState<any>(null);
  const [open, setOpen] = useState(false);

  const watchedFile = watch("file");

  const fetchOrderData = useCallback(async () => {
    if (!id) {
      setError("No order ID provided");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError("");
      const response: ApiResponse = await callAPI(`pharmacy/PrescriptionOrder/order-details/${id}`, Method.GET);
      console.log("API response:", response);
      
      if (response?.status && response?.data) {
        setOrderData(response.data);
      } else {
        setError("Order not found");
      }
    } catch (err) {
      console.error("Error fetching order:", err);
      setError("Failed to fetch order details");
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchOrderData();
  }, [fetchOrderData]);

  useEffect(() => {
    breadCrumbsStore.updateBreadCrumbs([
      { "Orders": "pharmacy-orders/list" },
      { [`Order #${id?.slice(-6).toUpperCase()}`]: `/pharmacy-orders/${id}` },
    ]);
  }, [id]);

  const handleOpenInvoice = () => {
    setInvoiceModalOpen(true);
  };

  const handleBillUpload = async (data: BillUploadFormData) => {
  if (!id || !data.file || data.file.length === 0) {
    alert("Please select an invoice file to upload");
    return;
  }

  setUploading(true);
  
  const formData = new FormData();
  const selectedFile = data.file[0];
  formData.append("file", selectedFile); // ✅ Backend expects "file"

  console.log("📤 UPLOADING:", selectedFile.name);

  try {
    const response = await callAPI(
      `pharmacy/PrescriptionOrder/${id}/upload-invoice`, // Your Prescription API
      Method.POST,
      formData
    );
    console.log("the response is ", response);

    console.log("✅ UPLOAD SUCCESS (undefined response = normal)");
    setBillUploadSuccess(true);
    alert("Invoice uploaded successfully!");
    await fetchOrderData(); // Refresh to show new invoiceUrl
    
    // Clear form
    setValue("file", null as any);
    
  } catch (error: unknown) {
    console.error("❌ Upload error:", error);
    
    // ✅ TYPE-SAFE HTTP STATUS CHECK
    let isHttpSuccess = false;
    try {
      const errorObj = error as any;
      if (errorObj?.response?.status === 200 || errorObj?.response?.status === 201) {
        isHttpSuccess = true;
      }
    } catch (e) {
      // Ignore - not an Axios-like error
    }

    if (isHttpSuccess) {
      console.log("✅ HTTP Success despite catch");
      setBillUploadSuccess(true);
      alert("Invoice uploaded successfully!");
      await fetchOrderData();
    } else {
      // ✅ TYPE-SAFE ERROR MESSAGE
      let errorMessage = "Try again";
      try {
        const errorObj = error as any;
        if (typeof errorObj?.message === 'string') {
          errorMessage = errorObj.message;
        }
      } catch (e) {
        // Use default message
      }
      alert("Upload failed: " + errorMessage);
    }
    
    // Always clear form
    setValue("file", null as any);
  } finally {
    setUploading(false);
    if (billUploadSuccess) {
      setTimeout(() => setBillUploadSuccess(false), 3000);
    }
  }
};


// ✅ Auto-hide success message
useEffect(() => {
  if (billUploadSuccess) {
    const timer = setTimeout(() => {
      setBillUploadSuccess(false);
    }, 3000);
    return () => clearTimeout(timer); // Cleanup
  }
}, [billUploadSuccess]);


 
  const timelineSteps = useMemo(() => {
    const timelineData = orderData?.timeline;
    const currentStatus = timelineData?.status?.toLowerCase() || "pending";
    
    const isDelivered = currentStatus.includes("delivered") || currentStatus.includes("completed");
    const isShipped = currentStatus.includes("shipped") || isDelivered;
    const isAssigned = currentStatus.includes("assigned") || isShipped;
    
    return [
      { 
        label: "Order Placed", 
        completed: !!timelineData?.orderPlaced || isAssigned,
        icon: <WSIcons.FiPackage /> 
      },
      { 
        label: "Delivery Assigned", 
        completed: !!timelineData?.deliveryAssigned || isAssigned,
        icon: <WSIcons.TbUserSquareRounded /> 
      },
      { 
        label: "Order Shipped", 
        completed: !!timelineData?.orderShipped || isShipped,
        icon: <WSIcons.RiRidingLine /> 
      },
      { 
        label: "Delivered", 
        completed: !!timelineData?.delivered || isDelivered,
        icon: <WSIcons.BsArrowUpSquare /> 
      },
    ];
  }, [orderData]);

  const itemsList = orderData?.orderInfo?.itemsName || "";

  const handleClick = () => {
  if (id) {
    navigate(`/prescription/${id}/bill-create`);  // ✅ Passes order ID
  } else {
    console.error("No order ID for navigation");
  }
};


  if (loading) {
    return (
      <>
        <WSBackButton id="btnScheduleBack" url="/pharmacy-orders/list" />
        <Paper style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
          <Typography>Loading order details...</Typography>
        </Paper>
      </>
    );
  }

  if (error || !orderData) {
    return (
      <>
        <WSBackButton id="btnScheduleBack" url="/pharmacy-orders/list" />
        <Paper style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
          <Typography color="error">{error || "Order not found"}</Typography>
        </Paper>
      </>
    );
  }

  return (
    <>
      <div>
        <WSBackButton id="btnScheduleBack" url="/pharmacy-orders/list" />

        {/* Timeline Section */}
        <Paper elevation={0} style={{ padding: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Order Timeline</Typography>
            </Grid>
            <Grid item xs={12}>
              <WSHorizontalTimeline steps={timelineSteps} />
            </Grid>
          </Grid>
        </Paper>

        {/* Order Summary */}
        <Paper elevation={0} style={{ padding: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
          <Grid container spacing={2} mt={2}>
            <Grid item sm={4} xs={12}>
              <Typography variant="body2" color="GrayText">Order ID</Typography>
            </Grid>
            <Grid item sm={4} xs={12}>
              <Typography variant="body2" color="GrayText">Technician Status</Typography>
            </Grid>
            <Grid item sm={2} xs={12}>
              <Typography variant="body2" color="GrayText">Delivery status</Typography>
            </Grid>
            <Grid item xs={12}><Divider style={{ marginTop: 10 }} /></Grid>
            
            <Grid item sm={4} xs={12}>
              <Typography fontWeight="bold">#HC{id?.slice(-6).toUpperCase()}</Typography>
            </Grid>
            <Grid item sm={4} xs={12}>
              <Typography variant="body2">{orderData.deliveryDetails.technicianStatus}</Typography>
            </Grid>
            <Grid item sm={2} xs={12}>
              <Typography variant="body2">{orderData.deliveryDetails.deliveryStatus}</Typography>
            </Grid>
            {/* <Grid item xs={12} sm={2}>
              <Grid 
                sx={{
                  display: "flex", 
                  alignItems: "center", 
                  gap: 1, 
                  px: 2, 
                  py: 1,
                  bgcolor: "#DDF6EC", 
                  borderRadius: 2, 
                  minWidth: 160, 
                  justifyContent: "center",
                  cursor: "pointer",
                  "&:hover": { bgcolor: "#C8F2DE" }
                }}
                onClick={handleOpenInvoice}
              >
                <Grid sx={{ color: "#33B78E", fontSize: 20, display: "flex", alignItems: "center" }}>
                  <WSIcons.VisibilityIcon />
                </Grid>
                <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#1E8A67" }}>
                  Delivery Report
                </Typography>
              </Grid>
            </Grid> */}
          </Grid>
        </Paper>

        {/* Patient & Order Info */}
        <Grid container spacing={2} mt={2}>
          <Grid item xs={12} sm={6}>
            <Paper elevation={0} style={{ padding: 20, paddingBottom: 25, borderRadius: "8px", height: "19rem" }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Patient Information</Typography>
                </Grid>
                <Grid item xs={12} sm={3}><Typography variant="body2" color="GrayText">Patient Name</Typography></Grid>
                <Grid item xs={12} sm={9}><Typography variant="body2">: {orderData.patient.username}</Typography></Grid>
                <Grid item xs={12} sm={3}><Typography variant="body2" color="GrayText">Contact Number</Typography></Grid>
                <Grid item xs={12} sm={9}><Typography variant="body2">: {orderData.patient.contactNumber}</Typography></Grid>
                <Grid item xs={12} sm={3}><Typography variant="body2" color="GrayText">Address</Typography></Grid>
                <Grid item xs={12} sm={9}>
                  <Typography variant="body2">: {orderData.patient.address}</Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Paper elevation={0} style={{ padding: 20, paddingBottom: 25, borderRadius: "8px", height: "19rem" }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Order Information</Typography>
                </Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Total Items</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: {orderData.orderInfo.totalItems}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Sub Total</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: ₹{orderData.orderInfo.subtotal.toFixed(2)}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Delivery Fee</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: ₹{orderData.orderInfo.deliveryFee}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Payment</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: {orderData.orderInfo.payment?.toUpperCase()}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Medicine Name</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: {itemsList}</Typography></Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>

        {/* Prescription Image */}
        {/* <Paper elevation={0} style={{ padding: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Prescription Image</Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
             <WSButton
                         id="btnAddNewProduct"
                         label="Add prescription"
                         startIcon={<AddIcon />}
                         onClick={handleClick}
                         sx={{
                           borderRadius: "999px", // pill shape
                           backgroundColor: "#098963!important", // green background
                           textTransform: "none", // prevent uppercase
                           fontWeight: 500,
                           height: "35px!important",
                           fontSize: "0.875rem!important",
                           paddingX: 3,
                           paddingY: 1,
                           "&:hover": {
                             backgroundColor: "#087654!important",
                           },
                         }}
                       />
            </Grid>
            <Grid item xs={12}><Divider /></Grid>
            <Grid item xs={12}>
              {orderData?.orderInfo.imageUrls && orderData.orderInfo.imageUrls.length > 0 ? (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                  <img
                    src={orderData.orderInfo.imageUrls[0].startsWith('http') 
                      ? orderData.orderInfo.imageUrls[0] 
                      : `${window.location.origin}${orderData.orderInfo.imageUrls[0]}`}
                    alt="Prescription"
                    style={{
                      maxWidth: '100%',
                      maxHeight: '400px',
                      objectFit: 'contain',
                      borderRadius: '8px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                    }}
                  />
                  <Typography variant="body2" color="textSecondary">
                    Prescription Image
                  </Typography>
                </Box>
              ) : (
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  height: '300px', 
                  border: '2px dashed #ccc', 
                  borderRadius: '8px',
                  bgcolor: '#f5f5f5'
                }}>
                  <Typography color="textSecondary" sx={{ textAlign: 'center' }}>
                    No prescription image available
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </Paper> */}


        {/* 🔥 Prescription Image Section - Using configData */}
<Paper elevation={0} style={{ padding: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
  <Grid container spacing={2}>
    <Grid item xs={12} sm={4}>
      <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Prescription Image</Typography>
    </Grid>
    <Grid item xs={12} sm={4}>
      <WSButton
        id="btnAddNewProduct"
        label="Add prescription"
        startIcon={<AddIcon />}
        onClick={handleClick}
        sx={{
          borderRadius: "999px",
          backgroundColor: "#098963!important",
          textTransform: "none",
          fontWeight: 500,
          height: "35px!important",
          fontSize: "0.875rem!important",
          paddingX: 3,
          paddingY: 1,
          "&:hover": {
            backgroundColor: "#087654!important",
          },
        }}
      />
    </Grid>
    <Grid item xs={12}><Divider /></Grid>
    <Grid item xs={12}>
      {orderData?.orderInfo.imageUrls && orderData.orderInfo.imageUrls.length > 0 ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <img
            src={
              orderData.orderInfo.imageUrls[0].startsWith('http') 
                ? orderData.orderInfo.imageUrls[0]
                : `${imgUrl}/${getCorrectedReportUrl(orderData.orderInfo.imageUrls[0])}`
            }
            alt="Prescription"
            style={{
              maxWidth: '100%',
              maxHeight: '400px',
              objectFit: 'contain',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}
          />
          <Typography variant="body2" color="textSecondary">
            Prescription Image
          </Typography>
        </Box>
      ) : (
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          height: '300px', 
          border: '2px dashed #ccc', 
          borderRadius: '8px',
          bgcolor: '#f5f5f5'
        }}>
          <Typography color="textSecondary" sx={{ textAlign: 'center' }}>
            No prescription image available
          </Typography>
        </Box>
      )}
    </Grid>
  </Grid>
</Paper>


        {/* Invoice Upload Section - EXACTLY LIKE PHARMACYORDERDETAILS */}
        <Paper elevation={0} style={{ padding: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Invoice Upload</Typography>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12} sm={6}>
              <form onSubmit={handleSubmit(handleBillUpload)}>
                <WSFileUpload
                  control={control as any}
                  name="file"
                  label="Upload Invoice"
                  id="file"
                />
                <Box mt={2}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={!watchedFile || watchedFile.length === 0 || uploading}
                    sx={{ mt: 1 }}
                  >
                    {uploading ? "Uploading..." : "Upload Invoice"}
                  </Button>
                  {billUploadSuccess && (
                    <Typography color="success.main" sx={{ ml: 2 }}>
                      ✓ Invoice uploaded successfully
                    </Typography>
                  )}
                </Box>
              </form>
            </Grid>
            <Grid item xs={12} sm={6}>
              {orderData.paymentInfo.invoiceUrl && (
                <Box>
                  <Typography variant="body2" color="GrayText" mb={1}>
                    Uploaded Invoice:
                  </Typography>
                  <img
                    src={orderData.paymentInfo.invoiceUrl}
                    alt="Uploaded Invoice"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "200px",
                      borderRadius: "8px",
                      border: "1px solid #ddd"
                    }}
                  />
                </Box>
              )}
            </Grid>
          </Grid>
        </Paper>

        {/* Delivery Details */}
        <Paper elevation={0} style={{ padding: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12}><Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Delivery Details</Typography></Grid>
            <Grid item xs={12}><Divider /></Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant="body2" color="GrayText" mt={2}>Assigned Technician:</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <Typography variant="body2" mt={2}>:{orderData.deliveryDetails.technicianName}</Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant="body2" color="GrayText" mt={2}>Technician Status:</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <Typography variant="body2" mt={2}>: {orderData.deliveryDetails.technicianStatus}</Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant="body2" color="GrayText" mt={2}>Delivery Status:</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <Typography variant="body2" mt={2}>: {orderData.deliveryDetails.deliveryStatus}</Typography>
            </Grid>
            <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Order ID</Typography></Grid>
            <Grid item xs={12} sm={8}><Typography variant="body2">: #HC{id?.slice(-6).toUpperCase()}</Typography></Grid>
            <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Order Date</Typography></Grid>
            <Grid item xs={12} sm={8}><Typography variant="body2">: {new Date(orderData.timeline.orderPlaced).toLocaleString()}</Typography></Grid>
            <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Delivery Location</Typography></Grid>
            <Grid item xs={12} sm={8}>
              <Typography variant="body2" mt={2}>:{orderData.deliveryDetails.deliveryAddress || orderData.patient.address}</Typography>
            </Grid>
          </Grid>
        </Paper>

        {/* Payment Information */}
        <Grid container spacing={2} mt={3}>
          <Grid item xs={12} sm={6}>
            <Paper elevation={0} style={{ padding: 20, paddingBottom: 25, borderRadius: "8px", height: "24rem" }}>
              <Grid container spacing={2}>
                <Grid item xs={12}><Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Payment Information</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Payment Status</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: {orderData.paymentInfo.paymentStatus}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Order Price</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: ₹{orderData.paymentInfo.orderPrice.toFixed(2)}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Delivery Price</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: ₹{orderData.paymentInfo.deliveryPrice}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Payment Method</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: {orderData.paymentInfo.paymentMode || 'Cash'}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Total</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2" fontWeight="bold">: ₹{(orderData.paymentInfo.orderPrice + orderData.paymentInfo.deliveryPrice).toFixed(2)}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Invoice</Typography></Grid>
                <Grid item xs={12} sm={8}> 
                  <Typography 
                    style={{ color: "#098963", cursor: "pointer", textDecoration: "underline" }} 
                    mt={2}
                    onClick={handleOpenInvoice}
                  >
                    View Invoice
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>

        {/* Invoice Modal */}
        <Dialog 
          open={invoiceModalOpen} 
          onClose={() => setInvoiceModalOpen(false)}
          maxWidth="lg"
          fullWidth
          PaperProps={{ sx: { height: "90vh" } }}
        >
          <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="h6">Prescription Order Invoice</Typography>
            <IconButton onClick={() => setInvoiceModalOpen(false)}>
              <WSIcons.CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ p: 0, height: "100%", overflow: "auto" }}>
            {id && <PrescriptionOrderInvoiceReport bookingId={id} />}
          </DialogContent>
        </Dialog>

        {/* Drawer for Order Info Edit */}
        {/* {formComponent && (
          <SwipeableDrawerForm
            anchor="right"
            title="Order Information"
            openForm={openDrawer}
            isEdit={true}
            formComponent={formComponent}
            onClose={() => {
              setOpenDrawer(false);
              setFormComponent(null);
            }}
          />
        )} */}
      </div>
    </>
  );
});

export default PrescriptionOrderDetails;

